export default __webpack_public_path__ + "static/media/time-icon.58fc3a2e.svg";